<template>
    <card :minify="minified">
        <card-header v-if="!minified">
            <card-title>
                <translate>neue Anfragen</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Lieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>Anfrageende</translate>
                    </th>
                    <th>
                        <translate>Verfahren</translate>
                    </th>
                    <th class="text-center">
                        <translate>bearbeiten</translate>
                    </th>
                    <th class="text-center">
                        <translate>ablehnen</translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="quote in newQuotesTable" :key="quote.index">
                    <td>
                        <Link :href="quote.url">{{ quote.ask_for_quote.pfnumber }}</Link>
                    </td>
                    <td class="text-center">
                        <file-download :sketch-file="quote.ask_for_quote?.producer_sketch_file" v-if="quote.ask_for_quote?.producer_sketch_file"/>
                        <file-download :cad-file="quote.ask_for_quote?.producer_cad_file" v-if="quote.ask_for_quote?.producer_cad_file"/>
                    </td>
                    <td class="text-right" v-html="quote.lot_qty"></td>
                    <td class="text-right">{{ quote.delivery_days_for_producer }} <translate>Tage</translate></td>
                    <td class="text-right">{{ quote.bidround_ending_at }}</td>
                    <td>{{ quote.abilities }}</td>
                    <td class="text-center">
                        <form-link-button :route="quote.url" dense="true" icon="document-edit" />
                    </td>
                    <td class="text-center">
                        <form-button type="button" dense="true" color="error" icon="delete-disabled" @click="rejectQuote(quote.bid_round_member)" />
                    </td>
                </tr>
                <tr v-if="noQuotes">
                    <td colspan="8" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
            <component-reject :bidRoundMember="rejectBidRoundMember" v-if="rejectDialog" @closeDialog="rejectDialog = false" />
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';
import ComponentReject from '@partfactory/Pages/Producer/Component/ComponentReject';

export default {
    name: 'DashboardNewQuotes',
    components: {ComponentReject, FileDownload, FormLinkButton, FormButton, CardContent, CardTitle, CardHeader, Card},
    props: {
        newQuotes: Object,
        abilities: Object,
        minified: Boolean,
    },
    data() {
        let  rejectDialog = false, rejectBidRoundMember = null;

        return {rejectDialog, rejectBidRoundMember};
    },
    computed: {
        newQuotesTable() {
            let quote = Array;

            return Object.keys(this.newQuotes).map(key => {
                quote[key] = this.newQuotes[key];

                let lotQty = [], lotAbilities = [];

                lotQty.push(quote[key].lotqty_1, quote[key].lotqty_2, quote[key].lotqty_3, quote[key].lotqty_4);
                quote[key].lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                quote[key].bidround_ending_at = this.$dateTime(quote[key].ending_at);

                quote[key].url = this.$$route('quote.show', {'bidRoundMember' : quote[key].bid_round_member.id});

                for (const [ab_key] of Object.entries(this.abilities.methods)) {
                    this.abilities.methods[ab_key].forEach((method) => {
                        if (quote[key]?.ask_for_quote.abilities?.methods[ab_key][method[0]]) {
                            lotAbilities.push(this.$gettext(method[1]));
                        }
                    });
                }

                quote[key].abilities = lotAbilities.join(', ');

                return quote[key];
            });
        },
        noQuotes() {
            return this.newQuotes.length === 0;
        },
    },
    methods: {
        rejectQuote(bidRoundMember) {
            this.rejectBidRoundMember = bidRoundMember;
            this.rejectDialog = true;
        }
    },

};
</script>
